import React from "react";

import connectToStores from "alt-utils/lib/connectToStores";
import TicketStore from "../../stores/TicketStore";
import CartTicketButton from "./cart-ticket-button.jsx";
import TicketListItem from "./ticket-list/ticket-list-item.jsx";

class AddTicketToCartButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buyingAdditionalTickets: false
    };
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object,
      muiTheme: React.PropTypes.object
    };
  }

  static getStores() {
    return [TicketStore];
  }

  static getPropsFromStores() {
    return {};
  }

  getStyles() {
    return {
      button: {}
    };
  }

  render() {
    let styles = this.getStyles(),
      { buyingAdditionalTickets } = this.state,
      { event, label, appSettings } = this.props;

    let tickets = TicketStore.getTicketsByEventId(event.id),
      ticketCount =
        tickets.length || (event.person ? event.person.ticket_count : 0),
      hasTickets = ticketCount > 0,
      isVirtual = event.is_virtual,
      isLikelySoldOut =
        !event.tickets_available ||
        event.ticket_buckets
          .filter(b => b.public)
          .every(b => b.quantity_remaining <= 0),
      isExpiredVirtual =
        isVirtual &&
        hasTickets &&
        tickets.every(
          t => Date.now() > new Date(t.expires_at || t.unlocked_until)
        ),
      showBuyAdditionalDropdown = !isVirtual || isExpiredVirtual;

    let customActions = (this.props.customActions || []).map(a => {
      return {
        label: a.label,
        onClick: () => {
          this.props.onAction({
            target: {
              event_id: event.id
            },
            action: "custom_action",
            custom_action_name: a.name
          });
        }
      };
    });

    return (
      <div style={{ position: "relative" }}>
        <CartTicketButton
          label={label}
          event={this.props.event}
          inline={true}
          appSettings={appSettings}
          order
          hideActions={this.props.hideActions}
          buyingAdditionalTicketsFromMenuOnly={
            this.props.hideScanTickets && buyingAdditionalTickets
          }
          hideOrderButton={this.props.hideScanTickets}
          customActions={customActions.concat(
            buyingAdditionalTickets
              ? [
                  {
                    label: "Back to my tickets",
                    onClick: () => {
                      this.setState({ buyingAdditionalTickets: false });
                    }
                  }
                ]
              : []
          )}
        />
      </div>
    );
  }
}

export default connectToStores(AddTicketToCartButton);



// WEBPACK FOOTER //
// ./src/app/components/partials/add-ticket-to-cart-button.jsx